"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const admin_1 = require("../../shared-types/admin");
exports.requestSchema = zod_1.z.object({
    id: zod_1.z.string(),
    description: zod_1.z.string(),
    permissionTypes: zod_1.z.array(admin_1.PermissionEntityTypeSchema).min(1),
});
exports.path = '/admin-upsert-permission';
//# sourceMappingURL=index.js.map